<form [formGroup]="form" class="app-install-trigger-form on-property-trigger-form">

  <app-flow-test-device-section
    [group]="$any(form.get('device'))"
    [modeOptions]="deviceModeOptions"
  ></app-flow-test-device-section>

  <app-flow-test-app-state-section
    [group]="$any(form.get('accountAppDevice'))"
    [modeOptions]="appStateModeOptions"
    [locationPermissionOptions]="locationPermissionOptions"
  ></app-flow-test-app-state-section>

  <app-flow-test-customer-section
    [group]="$any(form.get('accountAppUser'))"
    [modeOptions]="customerModeOptions"
    [userSearchTerm]="userSearchTerm"
    [userSearchResults]="userSearchResults"
    [userSearchLoading]="userSearchLoading"
    [selectedUser]="selectedUser"
    (searchInput)="onUserSearchInput($event)"
    (userPicked)="pickUser($event)"
    (userCleared)="clearUser()"
  ></app-flow-test-customer-section>

  <section formGroupName="onPropertyTiming" class="section">
    <header class="section-header">
      <h4>On-Property Timing</h4>
      <span class="hint">Required</span>
    </header>

    <div class="mode-toggle">
      <app-trigger-mode-radio-group
        formControlName="mode"
        [options]="timingModeOptions"
      ></app-trigger-mode-radio-group>
    </div>

    <p class="hint" *ngIf="timingMode === 'generate'">
      The runner will seed an active on-property visit that started 30 minutes
      ago, with a previous on-property visit 2 hours before that.
    </p>

    <div class="fields" *ngIf="timingMode === 'specify'">
      <div class="field">
        <label>Time On Property (minutes)</label>
        <mat-form-field appearance="outline">
          <input matInput type="number" formControlName="time_on_property_minutes" />
        </mat-form-field>
      </div>

      <div class="field">
        <label>Minutes Since Previous On-Property Visit</label>
        <mat-form-field appearance="outline">
          <input matInput type="number" formControlName="time_since_last_on_property_minutes" />
        </mat-form-field>
      </div>
    </div>

    <p class="hint" *ngIf="timingMode === 'specify'">
      Time on property controls <code>entry_at</code> for time-on-station
      conditions. The previous-visit value controls the packet's
      <code>last_on_property</code> for last-visit conditions.
    </p>
  </section>

  <section class="section location-context">
    <header class="section-header">
      <h4>Location Context</h4>
      <span class="hint">From selected account</span>
    </header>

    <p class="hint">
      The runner will use an existing on-property geofence or beacon region
      when one is available. If none exists, it will still seed generic
      on-property state so OnProperty flow conditions can evaluate.
    </p>
  </section>
</form>
